import { Local, type BaseURL } from './client'

export const baseUrl: BaseURL = import.meta.env.VITE_API_URL || Local
